/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

const navigationWrapper = document.querySelector('.navigation-wrapper')
const navigationMain = navigationWrapper.querySelector('.o-navigation--main')
const hamburger = navigationMain.querySelector('.js-hamburger')
const searchWrap = navigationWrapper.querySelector('.o-navigation__search')
const overlay = document.querySelector('.overlay')
const navigationAnchor = document.getElementById('navigation--anchor')

let isLoaded = false
let selected = false

window.addEventListener('load', () => {
	isLoaded = true
	hamburger.addEventListener('click', function () {
		document.documentElement.classList.toggle('navigation--is-open')
		this.classList.toggle('active')

		const targetElement = navigationWrapper.querySelector('.o-navigation--fullscreen');
		ScrollLock.toggleBodyScroll(targetElement)
	})

	overlay.addEventListener('click', function () {
		document.documentElement.classList.toggle('navigation--is-open')
		hamburger.classList.toggle('active')

		const targetElement = navigationWrapper.querySelector('.o-navigation--fullscreen');
		ScrollLock.toggleBodyScroll(targetElement)
	})

	searchWrap.addEventListener('click', function (e) {
		if (!selected) {
			selected = true
			this.classList.add('is-selected')
		} else if (selected && (event.target.matches('.o-navigation__search'))) {
			selected = false
			this.classList.remove('is-selected')
		}

		searchWrap.querySelector('input').focus()
	})

	if (navigationAnchor) {
		elOffset = offset(navigationAnchor)
	}
})

window.addEventListener('resize', () => {
	if (navigationAnchor) {
		offset(navigationAnchor)
	}
})

window.addEventListener('scroll', () => {
	if (isLoaded && navigationAnchor) {
		window.pageYOffset > elOffset - 100 ? navigationAnchor.classList.add('is-fixed') : navigationAnchor.classList.remove('is-fixed')
	}
});

function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return rect.top + scrollTop
}

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('contactModal') && !document.cookie.includes('modal=true')) {
		const modal = document.getElementById('contactModal');
		const closeModal = document.getElementById('close-modal');
		modal.classList.add('modal-active');

		closeModal.addEventListener('click', (e) => {
			modal.classList.remove('modal-active');
			document.cookie = 'modal=true; max-age=86400; path=/'
		});
	}
});


// WEBPACK FOOTER //
// ./js/modules/core/header/navigation.main.js